import {
  FormControl,
  FormControlLabel,
  InputLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";

export interface RadioGroupFieldProps {
  name?: string;
  label?: string;
  value?: string;
  onChange?: (ev, value: string) => void;
  options: {
    value: string;
    label: string;
    color?: "primary" | "secondary";
    disabled?: boolean;
  }[];
  labelStyle?: CSSProperties;
  radioStyle?: CSSProperties;
  margin?: "none" | "dense" | "normal";
}

const RadioGroupField = ({
  name,
  label,
  value,
  onChange,
  options,
  labelStyle = {},
  radioStyle = {},
  margin = "normal",
}: RadioGroupFieldProps) => (
  <FormControl component="fieldset" margin={margin}>
    <InputLabel
      shrink={true}
      variant="filled"
      style={{ transform: "translate(0px, -12px) scale(0.75)" }}
    >
      {label}
    </InputLabel>
    <RadioGroup name={name} value={value} onChange={onChange}>
      {options.map((option) => (
        <FormControlLabel
          key={option.value}
          value={option.value}
          control={
            <Radio
              color={option.color || "primary"}
              style={{ ...radioStyle }}
            />
          }
          label={option.label}
          disabled={option.disabled}
          style={{ ...labelStyle }}
        />
      ))}
    </RadioGroup>
  </FormControl>
);

RadioGroupField.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      color: PropTypes.oneOf(["primary", "secondary"]),
    })
  ).isRequired,
};

export default RadioGroupField;
